import Vue from 'vue'
import ElementUI from 'element-ui'
import store from '@/store/index'
// import store from './store/index'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App.vue'
import router from './router/index'
import i18n from '@/lang/index'
import VueRouter from 'vue-router';               //解决router的promise问题
import themeMixin from './lib/mixin'

// import './lib/rem'
const routerPush = VueRouter.prototype.push
import api from './http'    //挂载api到全局
VueRouter.prototype.push = function push(location) {
    return routerPush.call(this, location).catch(error=> error)
}
Vue.use(api)
router.beforeEach((to, from, next) => {

// chrome

    document.body.scrollTop = 0

// firefox

    document.documentElement.scrollTop = 0

// safari

    window.pageYOffset = 0

    next()

})
Vue.mixin(themeMixin)
//组件添加title和meta
import MetaInfo from 'vue-meta-info'
Vue.use(MetaInfo)


Vue.use(ElementUI)
window.vm=new Vue({
    router,
    i18n,
    store,
    render: h => h(App),
    mounted () {
        document.dispatchEvent(new Event('render-event'))
    }
}).$mount('#app')
